module.exports = __webpack_public_path__ + "img/stage_orangenminze.62c2f4e8.jpg";